@if (loggedIn) {
  <div class="holder">
    <div style="width: 30%;margin:0 auto;">
      <select id="statselect" [(ngModel)]="selectedConstant" (change)="setSelected(selectedConstant)">
        @for (type of constantTypes; track type) {
          <option [ngValue]="type">{{strings.artesStrings[type.value]}}</option>
        }
      </select>
    </div>
    <table id="tablettable" class="maintable">
      <tr>
        <th style="width:12.5%" (click)="sortTable('label')">{{strings.artesStrings['NAME']}}</th>
        <th style="width:12.5%" (click)="sortTable('amount')">{{strings.artesStrings['AMOUNT']}}</th>
      </tr>
      @for (i of selectedConstantArr; track i) {
        <tbody>
          <tr (click)="searchSkill(i.id)">
            <td>{{i.code}} {{i.infrastructure || i.station || i.category || i.engine || i.label || i.name}}</td>
            <td>{{i.amount}}</td>
          </tr>
        </tbody>
      }
    </table>
  </div>
}
